import { appInfo } from '../appInfo';
import { ProductId } from '../common';
import { getParam, isClient } from '../utils';
/**
 * 是否为测试环境的url
 */
var testUrl = getParam('test') === 'true';
/**
 * 是否为debug模式
 * 为真则上传打点日志时，会调用测试接口
 * 8888渠道默认开启debug模式(可能已经废弃)
 */
var $isTest = isClient &&
    /^https?:\/\/(mobiletest|yktpre|mobilelan)\.emoney\.cn/.test(location.href);
export var isTest = testUrl || $isTest;
export default {
    get DOMAIN_YKTAPI() {
        if (isTest) {
            return 'https://yktpre.emoney.cn/yktapi';
        }
        else {
            return "https://yktapi.emoney.cn";
        }
    },
    get DOMAIN_MSTAT() {
        if (isTest) {
            return 'https://mobiletest.emoney.cn/stat';
        }
        else {
            return "https://mstat.emoney.cn";
        }
    },
    /**
     * 漏斗打点地址
     */
    get userAnalysis() {
        var url = '';
        if (ProductId.Ycstock === appInfo.productId) {
            url = "".concat(this.DOMAIN_YKTAPI, "/statistics/UserAnalysis/ActivityTrackOne");
        }
        else {
            url = "".concat(this.DOMAIN_MSTAT, "/UserAnalysis/Advert/AddStatistics");
        }
        return url;
    },
    /**
     * 积分模块Url
     */
    get DOMAIN_EMAPP() {
        return isTest
            ? 'https://mobiletest.emoney.cn/emapp'
            : 'https://emapp.emoney.cn';
    },
    get DOMAIN_APPSTATIC() {
        return isTest
            ? 'https://mobiletest.emoney.cn/appstatic'
            : 'https://appstatic.emoney.cn';
    },
    get DOMAIN_APIMINAPP() {
        return isTest
            ? 'https://apiminapp.emoney.cn'
            : 'https://apiminapp.emoney.cn';
    },
    get DOMAIN_POINT() {
        return isTest
            ? 'https://mobilelan.emoney.cn/emapp/transfer/test.point.emoney.cn/'
            : 'https://emapp.emoney.cn/transfer/point.emoney.cn';
    },
    get DOMAIN_MLOG() {
        return 'https://emapp.emoney.cn/transfer/mlog.emoney.cn';
    }
};
//# sourceMappingURL=Urls.js.map